import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectCockpitGeoMappingItems = createSelector(
  [selectFinancialCockpitState],
  ({ geoMappingItems }) => geoMappingItems
)
